import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {AppContext} from "../../../app-context";
import {PortvisitUtils} from "../../../refdata/portvisit-utils";
import {NavigationItem} from "../overview-navigation-tabs/overview-navigation-tabs.component";

@Component({
    selector: 'app-navigation-toggle',
    templateUrl: './navigation-toggle.component.html',
    styleUrls: ['./navigation-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigationToggleComponent {
  protected readonly appContext = AppContext;
  protected readonly utils = PortvisitUtils;

  @Input() items: NavigationItem[];
}
